import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnablePackageDropdownGenericFallback = (): boolean => {
  return useFeatureFlag(FeatureFlagDeclarations.enablePackageDropdownGenericFallback);
};
